/**
 * Sign-in failures that are a person's mistake or a device condition, not a defect (#4630). The login handlers tell the
 * person on screen; logging these with console.error made the console bridge file each one as a Sentry error.
 *
 * AN ALLOWLIST OF EXACT CODES. `auth/internal-error` (how a broken beforeUserSignedIn blocking function surfaces) and
 * every unmapped `auth/error-code:-NN` are deliberately absent: those are the post-deploy breakage Sentry must catch.
 */
const EXPECTED_AUTH_CODES: ReadonlySet<string> = new Set([
  'auth/invalid-credential',
  'auth/user-not-found',
  'auth/wrong-password',
  'auth/invalid-email',
  'auth/network-request-failed',
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
]);

/** Codes only an email/password form can produce; from the Google flow they mean a broken or rotated provider config. */
const EMAIL_FORM_ONLY: ReadonlySet<string> = new Set([
  'auth/invalid-credential',
  'auth/user-not-found',
  'auth/wrong-password',
  'auth/invalid-email',
]);

export function isExpectedAuthError(error: unknown, flow: 'email' | 'google' = 'email'): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const code = (error as { code?: unknown }).code;
  if (typeof code !== 'string' || !EXPECTED_AUTH_CODES.has(code)) return false;
  return flow === 'email' || !EMAIL_FORM_ONLY.has(code);
}
